import { t } from "./kieli";

/**
 * Vaihe c (209; Toni 8.10.2026 «saahan valittua tulostekielen»): raportin kieli valitaan tulostushetkellä. Tyhjä =
 * kohteen dokumentaatiokieli (palvelin ratkaisee: kohde → instanssi → suomi). Valinta ei tallennu mihinkään: kohteen
 * oletus asetetaan Kohteet-näkymässä. Käyttöliittymän kieli ei vaikuta tulosteeseen.
 */
export function TulosteKieli({ arvo, muuta }: { arvo: string; muuta: (k: string) => void }) {
  return (
    <label style={{ display: "inline-flex", gap: 6, alignItems: "center" }} data-tulostekieli={arvo}>
      <span className="dim">{t("tuloste.kieli")}</span>
      <select value={arvo} onChange={(e) => muuta(e.target.value)} data-tulostekieli-valinta="">
        <option value="">{t("tuloste.kohteen_kieli")}</option>
        <option value="fi" lang="fi">Suomi</option>
        <option value="en" lang="en">English</option>
      </select>
    </label>
  );
}
